import { type Member } from '@/types';

export const normalizeMemberOptions = (members: Member[]) =>
  members?.map(({ user_id, full_name }) => ({
    label: full_name,
    value: user_id,
  }));
